<template>
  <ais-refinement-list :attribute="attribute" class="flex w-full mt-6">
    <template v-slot="{ items }">
      <div
        class="flex w-full flex-col bg-white rounded-lg p-6 mb-4 gap-y-4"
        style="box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.1);"
      >
        <h2 class="text-lg font-semibold">
          {{ title }}
        </h2>
        <div class="overflow-x-auto p-2">
          <div class="gap-x-6 w-[12.5rem] flex rounded-lg shadow-md">
            <router-link v-for="(item, index) in getItems(items)" :key="item.label" :to="listingLink(item, attribute)">
              <header-tooltip :tooltip-text="attributeDescriptionFunction(item.label)">
                <dashboard-card
                  :key="item.label"
                  :number="item.count"
                  :description="item.label"
                  class="min-w-[12.5rem]"
                  :data-test-id="`card-${index}`"
                >
                  <template v-if="iconLookupFunction" #icon>
                    <component :is="iconLookupFunction(item.label)?.value" />
                  </template>
                </dashboard-card>
                <template #tooltipIcon><component :is="iconLookupFunction(item.label)?.value" /></template>
              </header-tooltip>
            </router-link>
          </div>
        </div>
      </div>
    </template>
  </ais-refinement-list>
</template>
<script setup>
import { RouterLink } from "vue-router";
import { AisRefinementList } from "vue-instantsearch/vue3/es";
import { StudentStatus } from "../participantStatus";
import { useNavigatingLinks } from "../composables/useNavigatingLinks";
import { useRegisteredFacets } from "../composables/useRegisteredFacets";
import HeaderTooltip from "./HeaderTooltip.vue";
import DashboardCard from "./DashboardCard.vue";

const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  attribute: {
    type: String,
    default: "",
  },
  limit: {
    type: Number,
    default: 5,
  },
  descending: {
    type: Boolean,
    default: true,
  },
  useTooltip: {
    type: Boolean,
    default: false,
  },
  iconLookupFunction: {
    type: Function,
  },
  attributeDescriptionFunction: {
    type: Function,
  },
});

const { currentFacets } = useRegisteredFacets();
const { listingLink } = useNavigatingLinks(currentFacets.value);

const getItems = (items) => {
  const hasRefinements = items.some((item) => item.isRefined);
  return items
    .filter((item) => !hasRefinements || (hasRefinements && item.isRefined))
    .map((item) => ({
      ...item,
      order: Object.values(StudentStatus).find((status) => status.label === item.label)?.order || 99,
    }))
    .sort((a, b) => a.order - b.order);
};
</script>
<style scoped>
/* Scrollbar Width */
::-webkit-scrollbar {
  height: 6px;
}

/* Scrollbar Track */
::-webkit-scrollbar-track {
  background-color: #fafbff; /* Tailwind's bg-gray-100 */
}

/* Scrollbar Thumb */
::-webkit-scrollbar-thumb {
  background-color: #7a7a7a; /* Tailwind's bg-blue-500 */
  border-radius: 9999px; /* Tailwind's rounded-full */
}

/* Scrollbar Thumb on Hover */
::-webkit-scrollbar-thumb:hover {
  background-color: #7a7a7a; /* Tailwind's bg-blue-700 */
}
</style>
